<template>
  <div class="ma-0 mx-auto" style="min-height: 100%; max-width: 1000px;">
    <v-card style="max-width: 700px;" class="mx-auto py-2">
      <h2 class="mb-5">Polls</h2>

      <v-text-field v-model="searchQuery" label="Search Polls" prepend-icon="mdi-magnify" class="px-5 mb-3" hide-details
        dense outlined />

      <v-tabs v-model="tab" background-color="var(--v-primary-darken2)" dark grow class="mb-6">
        <v-tab>Active Polls</v-tab>
        <v-tab>Previous Polls</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div v-if="activePolls.length === 0" class="text-center grey--text"
            style="padding: 48px 0 32px 0; font-size: 1.1rem;">No active polls.</div>
          <v-row class="mx-2" v-else>
            <v-col v-for="poll in activePolls" :key="poll.poll_id" cols="12" md="6">
              <v-card class="poll-card poll-card-centered ma-2" elevation="6" @click="goToPoll(poll.poll_id)">
                <v-card-title class="headline poll-card-title-centered">{{ poll.title }}</v-card-title>
                <v-card-subtitle class="poll-card-subtitle-centered">{{ formatDate(poll.start_time) }} - {{
                  formatDate(poll.end_time) }}</v-card-subtitle>
                <v-card-text class="poll-card-text-centered">
                  <div class="mb-2 poll-card-desc-centered">{{ poll.description }}</div>
                  <div class="candidates-list poll-card-candidates-centered">
                    <div v-for="candidate in poll.candidates" :key="candidate.candidate_id" class="candidate-chip">
                      <v-chip color="primary" class="mr-2 mb-1" label>{{ candidate.name }}</v-chip>
                    </div>
                  </div>
                  <div v-if="userVotes[poll.poll_id]" class="mt-2">
                    <v-chip color="success" label>Your Vote: {{ getCandidateName(poll, userVotes[poll.poll_id])
                      }}</v-chip>
                  </div>
                </v-card-text>
                <v-card-actions class="poll-card-actions-centered">
                  <v-btn color="secondary" @click.stop="goToPoll(poll.poll_id)">View & Vote</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <div v-if="previousPolls.length === 0" class="text-center grey--text"
            style="padding: 48px 0 32px 0; font-size: 1.1rem;">No previous polls.</div>
          <v-row v-else>
            <v-col v-for="poll in previousPolls" :key="poll.poll_id" cols="12" md="6">
              <v-card class="poll-card previous poll-card-centered" elevation="2">
                <v-card-title class="headline poll-card-title-centered">{{ poll.title }}</v-card-title>
                <v-card-subtitle class="poll-card-subtitle-centered">{{ formatDate(poll.start_time) }} - {{
                  formatDate(poll.end_time) }}</v-card-subtitle>
                <v-card-text class="poll-card-text-centered">
                  <div class="mb-2 poll-card-desc-centered">{{ poll.description }}</div>
                  <div class="candidates-list poll-card-candidates-centered">
                    <div v-for="candidate in poll.candidates" :key="candidate.candidate_id" class="candidate-chip">
                      <v-chip color="primary" class="mr-2 mb-1" label>{{ candidate.name }}</v-chip>
                    </div>
                  </div>
                  <div v-if="userVotes[poll.poll_id]" class="mt-2">
                    <v-chip color="success" label>Your Vote: {{ getCandidateName(poll, userVotes[poll.poll_id])
                      }}</v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'Polls',

  components: {

  },

  props: {
    env: {
      type: Object,
      required: true,
    },

    userInfo: {
      type: Object,
      required: true,
    },

    polls: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    filteredPolls: [],
    searchQuery: '',
    tab: 0,
  }),

  watch: {
    polls: {
      handler(newValue) {
        this.filteredPolls = newValue;
      },
      immediate: true,
    },

    searchQuery: {
      handler(newValue) {
        this.filteredPolls = this.polls.filter(poll =>
          poll.title.toLowerCase().includes(newValue.toLowerCase())
        );
      },
      immediate: true,
    },
  },

  computed: {
    activePolls() {
      const now = new Date();
      return this.filteredPolls.filter(poll => new Date(poll.start_time) <= now && new Date(poll.end_time) >= now);
    },
    previousPolls() {
      const now = new Date();
      return this.filteredPolls.filter(poll => new Date(poll.end_time) < now);
    },
    userVotes() {
      // votes: [{ poll_id, candidate_id, ... }]
      if (!this.userInfo || !this.userInfo.votes) return {};
      const map = {};
      this.userInfo.votes.forEach(vote => {
        map[vote.poll_id] = vote.candidate_id;
      });
      return map;
    },
  },


  methods: {
    goToPoll(id) {
      this.$router.push(`/dashboard/${this.$route.path.match(/member|manager/i)[0]}/polls/${id}`);
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    },

    getCandidateName(poll, candidateId) {
      const c = poll.candidates.find(c => c.candidate_id === candidateId);
      return c ? c.name : 'Unknown';
    },
  },

  destroyed() {

  },

  created() {
    this.filteredPolls = this.polls;
  },

  mounted() {

  }
}
</script>
<style scoped>
.poll-card {
transition: box-shadow 0.2s, transform 0.2s;
cursor: pointer;
background: var(--v-background-base);
color: var(--v-foreground-base);
border-radius: 16px;
}
.poll-card:hover {
box-shadow: 0 8px 32px rgba(0,0,0,0.25);
transform: translateY(-2px) scale(1.01);
}
.poll-card.previous {
opacity: 0.85;
background: var(--v-secondary-lighten3);
}
.poll-card-centered {
display: flex;
flex-direction: column;
align-items: center;
text-align: center;
justify-content: center;
min-height: 270px;
}
.poll-card-title-centered {
width: 100%;
justify-content: center;
display: flex;
font-size: 1.35rem;
font-weight: 600;
letter-spacing: 0.5px;
color: var(--v-foreground-base);
}
.poll-card-subtitle-centered {
width: 100%;
justify-content: center;
display: flex;
color: var(--v-foreground-base);
font-size: 1rem;
margin-bottom: 8px;
}
.poll-card-text-centered {
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
padding: 0 12px;
}
.poll-card-desc-centered {
color: var(--v-foreground-base);
font-size: 1.08rem;
margin-bottom: 10px;
width: 100%;
}
.poll-card-candidates-centered {
justify-content: center;
}
.poll-card-actions-centered {
width: 100%;
display: flex;
justify-content: center;
margin-top: 10px;
}
.candidates-list {
display: flex;
flex-wrap: wrap;
margin-bottom: 8px;
}
.candidate-chip {
margin-right: 4px;
margin-bottom: 4px;
}
.v-card-title, .v-card-subtitle {
color: #fff;
}
.v-card-actions {
justify-content: flex-end;
}

</style>
